import { TabsModel } from '../models/tabs/tabs.model';
import { TabsStylingModel } from '../models/tabs/tabs-styling.model';

export const /** @type {?} */ TabsTemplates = {
  defaultTemplate: {
    property: new TabsModel({
      activeCardIndex: 0,
      display: true,
      disable: false,
      showCardNumberAsIcon: true,
      showCardNumberAsPrefix: false,
      indexBefore: true,
      headerPosition: 'above'
    }),
    style: new TabsStylingModel()
  }
}
